<template>
  <div>
    <div class="pos-kitchen-header">
      <div class="logo">
        <router-link to="/">
          <div class="logo-img">
            <img src="@/assets/icon-table-black.svg" />
          </div>
          <div class="logo-text">Pine & Dine</div>
        </router-link>
      </div>
      <div class="time ts-text-black" id="time">{{ time }}</div>
      <div class="nav ts-space-x-3">
        <div class="nav-item">
          <a-select 
            v-model="groupId" 
            :loading="loading" 
            :options="groups"
            showSearch
            :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
            placeholder="Product Group" 
            class="ts-w-64"
            @change="onGroupChange"
          ></a-select>
          <!-- <a href="#"
            @click.prevent="$emit('fetch')"
          >
            <i class="fas fa-sync"></i>
          </a>-->
          <!-- <router-link to="/pos/kitchen-order" class="nav-link">
            <svg
              viewBox="0 0 16 16"
              class="nav-icon"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 0 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8zm5.48-.079V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6zm0 3.75V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141z"
              />
            </svg>
          </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'bookingHeader',
  data() {
    return {
      loading: false,
      groups: [],
      groupId: undefined,
      time: '00:00'
    }
  },
  created() {
    this.handleStartTime()
    this.getProductGroup()
    this.groupId = parseInt(localStorage.getItem('group_id')) ? parseInt(localStorage.getItem('group_id')) : undefined
  },
  methods: {
    ...mapActions('restaurantSale/kdu', ['getGroup']),
    posMobileSidebarToggled: function() {
      this.posMobileSidebar = !this.posMobileSidebar
    },
    handleCheckTime: function(i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    handleStartTime: function() {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var a
      m = this.handleCheckTime(m)
      a = h > 11 ? 'pm' : 'am'
      h = h > 12 ? h - 12 : h

      this.time = h + ':' + m + a
      setTimeout(() => {
        this.handleStartTime()
      }, 500)
    },
    getProductGroup() {
      this.loading = true
      this.getGroup()
        .then(response => {
          this.groups = response.data.map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    onGroupChange(value){
      localStorage.setItem('group_id', value)
      this.$emit('change', value)
    }
  }
}
</script>